import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {SystemLicense} from "../interface/system-license";

@Injectable({
  providedIn: 'root'
})
export class SystemLicenseService {

  private baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) { }

  get(id: number): Observable<any>{
    return this.http.get(`${this.baseUrl}/get/system/license/${id}`);
  }

  getCollection(): Observable<SystemLicense[]>{
    return this.http.get<SystemLicense[]>(`${this.baseUrl}/get/system/licenses`);
  }
  getEnableCollection(): Observable<SystemLicense[]>{
    return this.http.get<SystemLicense[]>(`${this.baseUrl}/get/system/licenses`);
  }

  post(data: any): Observable<any>{
    return this.http.post<SystemLicense>(`${this.baseUrl}/create/system/license`, data);
  }

  validate(data: any): Observable<any>{
    return this.http.post<SystemLicense>(`${this.baseUrl}/validate/license/key`, data);
  }
  
  validateOnline(data: any): Observable<any>{
    //return this.http.post<any>(`https://back.quidak.com/api/validate/license/key`, data);
	return this.http.post<any>(`https://quidak.com/license.php`, data);
  }
  
  generate(): any{
    return this.http.get<SystemLicense[]>(`${this.baseUrl}/generate/license/key`);
  }

  put(id: number, data: SystemLicense): Observable<any>{
    return this.http.put<SystemLicense>(`${this.baseUrl}/edit/system/license/${id}`, data);
  }

  delete(id: number): Observable<SystemLicense>{
    return this.http.delete<SystemLicense>(`${this.baseUrl}/delete/system/license/` + id);
  }

  deleteMultiple(ids: number[]): Observable<SystemLicense[]>{
    const options = {body: ids};
    return this.http.delete<SystemLicense[]>(`${this.baseUrl}/delete/selected/system/licenses`, options);
  }
}
